module.exports = __webpack_public_path__ + "static/img/imgin.bcdd189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgin.png
// module id = FnEG
// module chunks = 5